import React, { PureComponent } from 'react';
import { View } from 'react-native';
import styles from './recent.search.styles';
import { H1, Large } from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
class RecentSearch extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      dataSource: this.props.data,
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      dataSource: nextProps.data,
    });
  }
  render() {
    const { i18n: { messages } } = this.props;
    let screenHeight = this.props.screen.height - 400 + 'px';

    return (
      <div className="search-grid profile-container">
        <H1 className="recent-search-title">
          {messages['app.Search.recentSearchTitle']}
        </H1>
        <div className="global-search">
          <NavigationList>
            {this.state.dataSource && this.state.dataSource.map((item, index) => (
              <NavigationListItem
                hasArrow
                onClick={() => this.props.selectedRow(item)}>
                  <View style={styles.portfolioText}>
                    <Large>{`${item.pfId}`}</Large>
                  </View>
                  <View style={styles.text}>
                    <Large>{`${item.psDesc}`}</Large>
                  </View>
              </NavigationListItem>
            ))
            }
          </NavigationList>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    screen: {
      height: true,
    },
    i18n: {
      messages: true,
    },
  },
})(RecentSearch);
